import { createFileRoute } from "@tanstack/react-router";
import { MovementDetail } from "@/features/movements";

/**
 * ONE MOVEMENT'S WHOLE HISTORY — pushed from the Movements tab in history.
 *
 * ⚠️ IT IS A TOP-LEVEL PATH AND NOT `/history/movements/:slug`, which is where the tab that
 * opens it lives. Two reasons, and the second is the one that decides it:
 *
 * · A movement is not a session, and everything under `/history/` is addressed by a log id.
 *   Nesting would put a slug where every sibling has a uuid.
 *
 * · 🔑 IT IS A LINK SOMEBODY SENDS THEMSELVES. "Where is my back squat going" is the question
 *   an athlete asks between sessions, from a notification or a bookmark, and a deep link into a
 *   tab's third panel has to restore the tab as well as the screen. `/movements/back-squat`
 *   restores itself.
 *
 * The screen owns its own header bar, the way every pushed screen in this app does, so the
 * route renders it whole rather than putting a title above it.
 */
export const Route = createFileRoute("/_app/movements/$movement")({
  component: MovementScreen,
});

function MovementScreen() {
  const { movement } = Route.useParams();

  return <MovementDetail movement={movement} />;
}
